import { StringParam, useQueryParams } from 'use-query-params'
import { useQuery } from '@tanstack/react-query'
import { NexusService } from 'global-apis/nexus-service'

export function useInvoiceDetails() {
  const [{ invoiceId }, setQueryParams] = useQueryParams({
    invoiceId: StringParam,
  })

  const setInvoiceId = (invoiceId?: string) => {
    setQueryParams({
      invoiceId,
    })
  }

  const isInvoiceDetailsDrawerOpen = !!invoiceId


  function payInvoiceByInvoiceId(documentNumber: string, subscriptionId: string, paymentAmount: number) {
    console.log('payInvoiceByInvoiceId: ', documentNumber, subscriptionId, paymentAmount)
    const { data: success, refetch } = useQuery({
      queryKey: ['/payInvoice'],
      queryFn: () =>
        NexusService.payInvoice(documentNumber, subscriptionId, paymentAmount).then((res) => {
            return res
          }
        ),
      refetchOnWindowFocus: false,
      enabled: false,
    }
    )

    return {
      success,
      doPayInvoiceById: refetch}
  }

  return {
    invoiceId,
    setInvoiceId,
    isInvoiceDetailsDrawerOpen,
    payInvoiceByInvoiceId,
  }
}

